import { formatISO, subDays, subMonths, subYears } from 'date-fns';

export const conversations = [
  {
    sessionType: 'chat',
    dateCreated: '2024-05-21T10:00:00.000Z',
    status: 'active',
    countMetadata: {
      messageCount: 5,
      unreadCount: 2,
    },
    conversationSubject: 'License Renewal',
    sessionId: 'session123',
  },
  {
    sessionType: 'chat',
    dateCreated: '2024-06-15T14:30:00.000Z',
    status: 'active',
    countMetadata: {
      messageCount: 3,
      unreadCount: 1,
    },
    conversationSubject: 'Technical Support',
    sessionId: 'session124',
  },
  {
    sessionType: 'chat',
    dateCreated: '2024-07-10T09:45:00.000Z',
    status: 'closed',
    countMetadata: {
      messageCount: 8,
      unreadCount: 0,
    },
    conversationSubject: 'Billing Inquiry',
    sessionId: 'session125',
  },
];

export const messages = [
  {
    sessionId: 'session123',
    data: {
      page: '1',
      sessionType: 'chat',
      total: '1',
      records: '3',
      rows: [
        {
          commentId: '4b96194c-336b-4832-b467-65169fa2f9b5',
          objectId: 'ea56fa1d-ffd6-4fba-87ac-9ef22ee2364a',
          comment: 'jkjj',
          documentId: 'ebc99d87-e5bd-4d1c-9c90-25f438d4827e',
          dateCreated: '2024-11-21T07:22:52.414903Z',
          createdBy: '{"appUserId": "userName"}',
          parentCommentId: null,
          documentMetadata:
            '{"dateCreated": "2024-11-21T08:22:52.382+0100", "documentName": "upload_5961174163568161432_Employee-Handbook.pdf", "documentPath": "2024-11/files/RDRKv0LG2M______upload_5961174163568161432_Employee-Handbook.pdf", "documentDescription": "upload_5961174163568161432_Employee-Handbook.pdf"}',
          parentCommentMetadata: null,
          position: 3,
        },
        {
          commentId: '8b0b23c0-33a7-4468-9270-512569036451',
          objectId: 'ea56fa1d-ffd6-4fba-87ac-9ef22ee2364a',
          comment: 'look',
          documentId: '5e49d10a-eba4-40b3-8f8a-aa8778966c32',
          dateCreated: '2024-11-21T07:13:11.776776Z',
          createdBy: '{"appUserId": "AI"}',
          parentCommentId: null,
          documentMetadata:
            '{"dateCreated": "2024-11-21T08:13:11.571+0100", "documentName": "upload_4955099598083705225_start.bat", "documentPath": "2024-11/files/5eZtWn1WGE______upload_4955099598083705225_start.bat", "documentDescription": "upload_4955099598083705225_start.bat"}',
          parentCommentMetadata: null,
          position: 2,
        },
        {
          commentId: 'a6a807ed-7e12-4875-9997-4b25d8e40b43',
          objectId: 'ea56fa1d-ffd6-4fba-87ac-9ef22ee2364a',
          comment: 'test',
          documentId: null,
          dateCreated: '2024-10-23T01:27:55.637352Z',
          createdBy: '{"appUserId": "userName"}',
          parentCommentId: null,
          documentMetadata: null,
          parentCommentMetadata: null,
          position: 1,
        },
      ],
    },
  },
  {
    sessionId: 'session124',
    data: {
      page: '1',
      total: '1',
      records: '2',
      sessionType: 'chat',
      rows: [
        {
          commentId: 'b1c2d3e4-5678-9101-1121-314151617181',
          objectId: 'fa56fa1d-ffd6-4fba-87ac-9ef22ee2364b',
          comment: 'I need help with my account.',
          documentId: null,
          dateCreated: '2024-06-15T14:31:00.000Z',
          createdBy: '{"appUserId": "userName"}',
          parentCommentId: null,
          documentMetadata: null,
          parentCommentMetadata: null,
          position: 1,
        },
        {
          commentId: 'c2d3e4f5-6789-1011-1213-141516171819',
          objectId: 'fa56fa1d-ffd6-4fba-87ac-9ef22ee2364b',
          comment: 'Sure, what seems to be the problem?',
          documentId: null,
          dateCreated: '2024-06-15T14:32:00.000Z',
          createdBy: '{"appUserId": "AI"}',
          parentCommentId: 'b1c2d3e4-5678-9101-1121-314151617181',
          documentMetadata: null,
          parentCommentMetadata: null,
          position: 2,
        },
      ],
    },
  },
  {
    sessionId: 'session125',
    data: {
      page: '1',
      total: '1',
      records: '3',
      sessionType: 'chat',
      rows: [
        {
          commentId: 'd3e4f5g6-7890-1011-1213-141516171819',
          objectId: 'ga56fa1d-ffd6-4fba-87ac-9ef22ee2364c',
          comment: 'I have a question about my bill.',
          documentId: null,
          dateCreated: '2024-07-10T09:46:00.000Z',
          createdBy: '{"appUserId": "userName"}',
          parentCommentId: null,
          documentMetadata: null,
          parentCommentMetadata: null,
          position: 1,
        },
        {
          commentId: 'e4f5g6h7-8901-1011-1213-141516171819',
          objectId: 'ga56fa1d-ffd6-4fba-87ac-9ef22ee2364c',
          comment: 'Can you provide more details?',
          documentId: null,
          dateCreated: '2024-07-10T09:47:00.000Z',
          createdBy: '{"appUserId": "userName"}',
          parentCommentId: 'd3e4f5g6-7890-1011-1213-141516171819',
          documentMetadata: null,
          parentCommentMetadata: null,
          position: 2,
        },
        {
          commentId: 'f5g6h7i8-9012-1011-1213-141516171819',
          objectId: 'ga56fa1d-ffd6-4fba-87ac-9ef22ee2364c',
          comment: 'I was charged twice for the same service.',
          documentId: null,
          dateCreated: '2024-07-10T09:48:00.000Z',
          createdBy: '{"appUserId": "userName"}',
          parentCommentId: 'e4f5g6h7-8901-1011-1213-141516171819',
          documentMetadata: null,
          parentCommentMetadata: null,
          position: 3,
        },
      ],
    },
  },
];

const today = new Date();
const sevenDaysAgo = subDays(today, 6);
const nineDaysAgo = subDays(today, 9);
const thirtyDaysAgo = subDays(today, 30);
const oneYearAgo = subYears(today, 1);

export const history = [
  {
    topic: 'Artificial Intelligence in Healthcare',
    id: '1a2b3c4d',
    userId: 'user123',
    sessionMode: 'discussion',
    createdAt: formatISO(today),
    updatedAt: formatISO(today),
    lastActivityDate: formatISO(today),
  },
  {
    topic: 'Climate Change Impact on Agriculture Seven',
    id: '2b3c4d5e',
    userId: 'user456',
    sessionMode: 'research',
    createdAt: formatISO(sevenDaysAgo),
    updatedAt: formatISO(sevenDaysAgo),
    lastActivityDate: formatISO(sevenDaysAgo),
  },
  {
    topic: 'Climate Change Impact on Agriculture Nine',
    id: '2b3c4d5e',
    userId: 'user456',
    sessionMode: 'research',
    createdAt: formatISO(nineDaysAgo),
    updatedAt: formatISO(nineDaysAgo),
    lastActivityDate: formatISO(nineDaysAgo),
  },
  {
    topic: 'Blockchain and Financial Services 30',
    id: '3c4d5e6f',
    userId: 'user789',
    sessionMode: 'brainstorming',
    createdAt: formatISO(thirtyDaysAgo),
    updatedAt: formatISO(thirtyDaysAgo),
    lastActivityDate: formatISO(thirtyDaysAgo),
  },
  {
    topic: 'Quantum Computing Breakthroughs one year',
    id: '4d5e6f7g',
    userId: 'user234',
    sessionMode: 'conference',
    createdAt: formatISO(oneYearAgo),
    updatedAt: formatISO(oneYearAgo),
    lastActivityDate: formatISO(oneYearAgo),
  },
  // Additional data items can be added here if needed
];
